<template>
  <div class="VipCard">
    <div v-if="dataList.list.length === 0" class="notcot">
      <div class="ntbox">
        <img :src="require('@/assets/images/icon/enpty.png')" />
        <br />
        <span>还没有记录哦~</span>
      </div>
    </div>
    <van-list
      v-model="dataList.loading"
      :finished="dataList.finished"
      finished-text="没有更多了"
      @load="userCardList"
    >
      <van-cell class="no-border-cell" v-for="v in dataList.list" :key="v.id">
        <ul class="car-list">
          <li>
            <div class="cell-li">
              <div class="left">
                <span class="small">￥</span>
                <span class="big">{{v.cardMoney|priceFilter}}</span>
              </div>
              <div class="middle nowrap">
                {{v.cardName}}
                <span class="use-rule" @click="handleCheck(v)">
                  使用规则
                  <van-icon name="arrow-down" :class="selectId==v.id?'active':''" />
                </span>
              </div>
              <div class="right">
                <van-button @click="getAward(v)">领取</van-button>
              </div>
            </div>
            <transition name="van-slide-down">
              <div class="later" v-if="selectId==v.id">
                <span
              v-html="
                v.useRule
                  ? v.useRule.replace(/\n/g, '<br>')
                  : ''
              "></span>
              </div>
            </transition>
          </li>
        </ul>
      </van-cell>
    </van-list>
    <!-- <ul class="car-list">
      <li v-for="v in dataList.list" :key="v.id">
        <div class="cell-li">
          <div class="left">
            <span class="small">￥</span>
            <span class="big">{{v.cardMoney|priceFilter}}</span>
          </div>
          <div class="middle">
            <span class="big">{{v.cardName}}</span>
            <span class="use-rule" @click="handleCheck(v)">
              使用规则
              <van-icon name="arrow-down" :class="selectId==v.id?'active':''" />
            </span>
          </div>
          <div class="right">
            <van-button @click="getAward(v)">领取</van-button>
          </div>
        </div>
        <transition name="van-slide-down">
          <div class="later" v-if="selectId==v.id">
                <span
              v-html="
                v.useRule
                  ? v.useRule.replace(/\n/g, '<br>')
                  : ''
              "></span>
          </div>
        </transition>
      </li>
    </ul>-->
  </div>
</template>
<script>
export default {
  name: "GetCard",
  data () {
    return {
      carList: [],
      selectId: null,
      dataList: {
        current: 1,
        size: 10,
        list: [],
        empty: 0,
        finished: false,
        loading: false // 异步加载状态
      } // 列表
    };
  },
  computed: {},
  mounted () {
  },
  methods: {
    // 查看使用规则
    handleCheck (v) {
      if (this.selectId === v.id) this.selectId = null;
      else this.selectId = v.id;
    },
    // 领取
    async getAward (v) {
      // user/userCard/addNewUserCard
      let res = await this.request("/user/userCard/addNewUserCard", {
        newUserCardId: v.id
      });
      if (res.code === 0) {
        this.$error("领取成功");
        this.laterGoBack();
      }
    },
    async userCardList () {
      try {
        this.$loading("加载中");
        let pageJson = {
          page: this.dataList.current,
          limit: this.dataList.size
        };
        let result = await this.request("/card/cardNewUser/list", { ...pageJson });
        this.$loadingClose();
        result.List = result.List.map(it => {
          return {
            ...it
          };
        });
        if (this.dataList.current === 1) this.dataList.list = result.List;
        else this.dataList.list = [...this.dataList.list, ...result.List];
        this.$nextTick(() => {
          if (result.List.length < result.TotalCount) {
            this.dataList.current++;
          }
          this.dataList.loading = false;
          // 数据全部加载完成
          if (this.dataList.list.length >= result.TotalCount) {
            this.dataList.finished = true;
          }
        });
      } catch (e) {
        this.$loadingClose();
        this.$error(e.message);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
.ntbox {
  padding-top: 50%;
  color: #bbbbbb;
}
.notcot {
  width: 100%;
  height: 100vh;
  background-color: #f8f8f8;
  text-align: center;
}
.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
.car-list {
  margin-top: 15px;
  li {
    overflow: hidden;
    margin-bottom: 20px;
    .cell-li {
      .flex-center();
      position: relative;
      flex-wrap: wrap;
      justify-content: space-between;
      background: rgb(236, 247, 255);
      margin: 0 20px;
      padding: 10px 15px;
      .left {
        width: 60px;
        span {
          color: #0096ff;
          font-size: 14px;
          &.big {
            font-size: 22px;
          }
        }
      }
      .middle {
        width: 150px;
        margin-right: 5px;
        border-right: 2px dashed #0096ff;
        padding: 0 15px;
        width: 35%;
        flex: 1;
        span {
          display: block;
          &.big {
            color: #055790;
            font-size: 15px;
            padding-bottom: 8px;
          }
          &.use-rule {
            color: #585858;
            .van-icon {
              transition: transform 0.3s;
            }
          }
          .active {
            transform: rotate(-180deg);
          }
        }
      }
      .right {
        margin-left: 15px;
        .van-button {
          background: linear-gradient(
            90deg,
            rgba(66, 177, 255, 1) 0%,
            rgba(26, 156, 253, 1) 100%
          );
          font-size: 12px;
          color: #fff;
          padding: 0 20px;
          height: 25px;
          line-height: 25px;
          display: block;
          border-radius: 20px;
          margin-bottom: 5px;
        }
      }
    }
    .later {
      background: #f7fbff;
      margin: 0 20px;
      padding: 10px;
      position: relative;
      z-index: -1;
    }
  }
  .nowrap {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>